import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {addEditKitchenReady} from '../redux/kitchens'
import apiService from '../services/apiservices'
import { headerDataUpdate, buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'
//import  {ValidateEmail ,ValidatePhone,isLatitude,isLongitude} from '../../../common/ValidationFunctions/CommonValidation'


import {Cities,Employees,EntityStatus,ClusterCombo} from '../../../common/DropDowns/index'
//import * as Helpers from '../../../common/helpers'

class AddEditKitchen extends Component {

    constructor() {
        super()
        this.state = {
            
            bodyHeight: "0px",
            editFlag:false,

            kitchenName:null,
            kitchenCode:null,
            cityId:0,
            totalBudegetedCounts:0,
            contactNo:"",        

            kitchenData: {},

            budgetedKitchenStaffData:[],

            clusterId:"",

            managerId:"",
            lat:"",
            lng:"",
            BudgetedHk:"",
            BudgetedKm:"",
            BudgetedAkm:"",
            BudgetedSm:"", 
            status:"",

        statusErrorText: false,
        statusErrorData: '',     

            BudgetedKmErrorText: false,
            BudgetedKmErrorData: '',     
            

            BudgetedSmErrorText: false,
            BudgetedSmErrorData: '',     
        

            BudgetedHkErrorText: false,
            BudgetedHkErrorData: '',  

            BudgetedAkmErrorText: false,
            BudgetedAkmErrorData: '',     
            
            

            lngErrorText: false,
            lngErrorData: '',    

            latErrorText: false,
            latErrorData: '',     
            

            managerIdErrorText: false,
            managerIdErrorData: '',    
            
            

            clusterIdErrorText: false,
            clusterIdErrorData: '',     
               
            
            kitchenNameErrorText: false,
            kitchenNameErrorData: '',

            kitchenCodeErrorText: false,
            kitchenCodeErrorData: '',

            
            cityIdErrorText: false,
            cityIdErrorData: '',
        

            contactNoErrorText: false,
            contactNoErrorData: '',  

            
            subTitle: Constants.ADD_KITCHEN
            
        }
        this.isComponentStillMounted = true

        this.kitchenNameComponent = null
        this.kitchenNameSection = null

        this.kitchenCodeComponent = null
        this.kitchenCodeSection = null

        this.cityIdComponent = null
        this.cityIdSection = null

        this.contactNoComponent = null
        this.contactNoSection = null  
        
    this.clusterIdComponent = null
    this.clusterIdSection = null
    

    this.managerIdComponent = null
    this.managerIdSection = null

        
    this.latComponent = null
    this.latSection = null

        
        
    this.lngComponent = null
    this.lngSection = null
        
    this.BudgetedSmComponent = null
    this.BudgetedSmSection = null
        
    this.BudgetedKmComponent = null
    this.BudgetedKmSection = null
        
    this.BudgetedHkComponent = null
    this.BudgetedHkSection = null

        
    this.BudgetedAkmComponent = null
    this.BudgetedAkmSection = null


        
    this.statusComponent = null
    this.statusSection = null
    
    
    
    
    
        
        

     
    }

    componentWillMount() {
        this.isComponentStillMounted = true
        
        if(this.props.kitchens && this.props.kitchens.kitchenSelectedId && this.props.kitchens.kitchenSelectedId !== null){
            this.props.dispatch(headerDataUpdate(Constants.EDIT_KITCHEN))
            this.setState({
                subTitle: "Edit Kitchen",
                editFlag:true
            })

            this.getKitchensDataById(this.props.kitchens.kitchenSelectedId)
        }else{
            this.props.dispatch(headerDataUpdate(Constants.ADD_KITCHEN))
            this.setState({subTitle: "Add Kitchen"})

            this.props.dispatch(addEditKitchenReady(false))
            this.getBrandGroups();
        }
        
        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()
    }

    componentDidMount() {
        this.kitchenNameSection = ReactDOM.findDOMNode(this.refs.kitchenNameSection)
        this.cityIdSection = ReactDOM.findDOMNode(this.refs.cityIdSection)
        this.kitchenCodeSection = ReactDOM.findDOMNode(this.refs.kitchenCodeSection)    
        this.contactNoSection = ReactDOM.findDOMNode(this.refs.contactNoSection)
        this.clusterIdSection = ReactDOM.findDOMNode(this.refs.clusterIdSection)     
        this.managerIdSection = ReactDOM.findDOMNode(this.refs.managerIdSection) 
        this.latSection = ReactDOM.findDOMNode(this.refs.latSection)
        this.lngSection = ReactDOM.findDOMNode(this.refs.lngSection)
        this.BudgetedKmSection = ReactDOM.findDOMNode(this.refs.BudgetedKmSection)
        this.BudgetedSmSection = ReactDOM.findDOMNode(this.refs.BudgetedSmSection)
        this.BudgetedHkSection = ReactDOM.findDOMNode(this.refs.BudgetedHkSection)  
        this.BudgetedAkmSection = ReactDOM.findDOMNode(this.refs.BudgetedAkmSection)        
        this.statusSection = ReactDOM.findDOMNode(this.refs.statusSection)

    }


    getKitchensDataById=(kitchenId)=>{
        this.props.dispatch(addEditKitchenReady(false))
       
            apiService.getKitchensDataById(kitchenId)
                .then(responseData => {
                    if (this.isComponentStillMounted && responseData.status === "SUCCESS") {
                        this.kitchenNameComponent.value=responseData.data.name
                        this.kitchenCodeComponent.value=responseData.data.code
                        this.cityIdComponent.value=responseData.data.city_id
                        this.managerIdComponent.value=responseData.data.manager_id
                        this.contactNoComponent.value=responseData.data.contact_no
                        this.latComponent.value=responseData.data.lat
                        this.lngComponent.value=responseData.data.lng
                        this.BudgetedKmComponent.value=responseData.data.budgeted_km
                        this.BudgetedSmComponent.value=responseData.data.budgeted_sm
                        this.BudgetedAkmComponent.value=responseData.data.budgeted_akm
                        this.BudgetedHkComponent.value=responseData.data.budgeted_hk
                        this.statusComponent.value=responseData.data.status
                        this.clusterIdComponent.value=responseData.data.cluster_id

                        this.setState({
                            kitchenData:responseData.data,
                            kitchenName:responseData.data.name,
                            kitchenCode:responseData.data.code,
                            cityId:responseData.data.city_id,
                            managerId:responseData.data.manager_id,
                            contactNo:responseData.data.contact_no,
                            lat:responseData.data.lat,
                            lng:responseData.data.lng,
                            BudgetedKm:responseData.data.budgeted_km,
                            BudgetedSm:responseData.data.budgeted_sm,
                            BudgetedHk:responseData.data.budgeted_hk,
                            BudgetedAkm:responseData.data.budgeted_akm,
                            status:responseData.data.status,
                            clusterId:responseData.data.cluster_id
                        })

                        this.getBrandGroups(responseData.data.budgeted_kitchen_staffs);
                    }
                })
                .catch(err => {
                    console.log("Error data: ", err)
                    this.props.dispatch(addEditKitchenReady(true))
                    this.dialog.show({
                        title: "Server respond with Error data",
                        body: 'Product creation got interrupted',
                        actions: [
                            Dialog.OKAction(() => {
                                this.props.history.goBack()
                            })
                        ],
                        onHide: (dialog) => {
                            dialog.hide()
                            this.props.history.goBack()
                        }
                    })
                })
    }

    updateDimensions = () => {
        if (window.innerWidth <= 767) {
            this.setState({
                bodyHeight: (window.innerHeight - 120) + "px",
            })
        } else {
            this.setState({
                bodyHeight: (window.innerHeight - 120) + "px",
            })
        }
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }


    getBrandGroups=(brandGroups=[])=>{
         apiService.getBrandGroupsCombo()
                .then(responseData => {
                    this.props.dispatch(addEditKitchenReady(true))
                    if(this.isComponentStillMounted && responseData.status === "SUCCESS") {
                         let list = {}
                            list = Object.keys(responseData.data).map((value,index) => {
                                
                                return {
                                    name : responseData.data[value],
                                    brand_group_id : value,
                                    count:0,
                                }
                            })
                            list.sort((a,b) => a.name.localeCompare(b.name));

                            for(let i=0;i<brandGroups.length;i++){
                                for(let j=0;j<list.length;j++){
                                    if(parseInt(list[j]['brand_group_id'],10)===brandGroups[i]['brand_group_id']){
                                        list[j]['count']=brandGroups[i]['count']
                                        list[j]['id']=brandGroups[i]['id']
                                    }
                                }
                            }

                             let total=0;

                            list.map(function(item, index) {                               
                                total+=item['count']!=="" ? parseInt(item['count'],10) : 0
                                return true
                            })

                            this.setState({
                                budgetedKitchenStaffData: list,
                                totalBudegetedCounts : total
                            });
                    }
                })
                .catch(err => {
                    console.log("Error data: ", err)
                    this.props.dispatch(addEditKitchenReady(true))
                    this.dialog.show({
                        title: "Server respond with Error data",
                        body: 'Getting store groups got interrupted',
                        actions: [
                            Dialog.OKAction(() => {
                            })
                        ],
                        onHide: (dialog) => {
                            dialog.hide()
                        }
                    })
                })
        
    }

    cityChange = (data) => {
        console.log(data)
       this.setState({citySelectedId:data.value})
        if(!data.value){
            this.setState({
                state:'',
                country:''
               
            })
            return
        }else{
            this.stateComponent=data.state_name
            this.setState({ cityErrorText: false, cityErrorData: '',state:data.state_name,
            country:data.country_name })
            this.citySection.className = this.citySection.className.replace(" has-error", "")
            this.props.dispatch(addEditKitchenReady(false))
        }
    }



 cityChange = (data) => {
    this.cityIdComponent.value=data.value
        this.setState({
            cityId :data.value,
            cityIdErrorText: false,
            cityIdErrorData: ''
        })
        this.cityIdSection.className= this.cityIdSection.className.replace(" has-error", "")
    }



    

clusterIdChange= (data) => {
    this.clusterIdComponent.value=data.value
        this.setState({
            clusterId :data.value,
            clusterIdErrorText: false,
            clusterIdErrorData: ''
        })
        this.clusterIdSection.className= this.clusterIdSection.className.replace(" has-error", "")
    }


managerIdChange= (data) => {
    this.managerIdComponent.value=data.value
        this.setState({
            managerId :data.value,
            managerIdErrorText: false,
            managerIdErrorData: ''
        })
        this.managerIdSection.className= this.managerIdSection.className.replace(" has-error", "")
    }



statusChange= (data) => {
    this.statusComponent.value=data.value
        this.setState({
            status :data.value,
            statusErrorText: false,
            statusErrorData: ''
        })
        this.statusSection.className= this.statusSection.className.replace(" has-error", "")
    }

    
mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}

    onSaveClick = () => {
        let data ={}

        let kitchenNameObject = this.mandateValidation("kitchenName",Constants.FORM_INPUT)
        if (kitchenNameObject.status) {
            data.name = this.state.kitchenName
        } else {
            return
        }

        let kitchenCodeObject = this.mandateValidation("kitchenCode",Constants.FORM_INPUT)
        if (kitchenCodeObject.status) {
            data.code = this.state.kitchenCode
        } else {
            return
        }

        if(this.state.status==="ACTIVE"){

            let cityIdObject = this.mandateValidation("cityId",Constants.FORM_SELECT)
            if (cityIdObject.status) {
                data.city_id = this.state.cityId
            } else {
                return
            }
            
            let contactNoObject = this.mandateValidation("contactNo",Constants.FORM_INPUT)
            if (contactNoObject.status) {
                data.contact_no = this.state.contactNo
            } else {
                return
            }
            

            let clusterIdObject = this.mandateValidation("clusterId",Constants.FORM_SELECT)
            if (clusterIdObject.status) {
                data.cluster_id = this.state.clusterId
            } else {
                return
            }

        }

        // let managerIdObject = this.mandateValidation("managerId",Constants.FORM_SELECT)
        // if (managerIdObject.status) {
        //     data.manager_id = this.state.managerId
        // } else {
        //     return
        // }


        data.manager_id = this.state.managerId

        if(data.manager_id===undefined || data.manager_id===""){
            data.manager_id=0
        }

        data.lat=this.state.lat
        data.lng=this.state.lng
        data.budgeted_km=this.state.BudgetedKm
        data.budgeted_hk=this.state.BudgetedHk
        data.budgeted_sm=this.state.BudgetedSm
        data.budgeted_akm=this.state.BudgetedAkm

        let statusObject = this.mandateValidation("status",Constants.FORM_SELECT)
        if (statusObject.status) {
            data.status = this.state.status
        } else {
            return
        }

         data.budgeted_ks=this.state.budgetedKitchenStaffData;


    let apiPayloadData=data;


    this.props.dispatch(addEditKitchenReady(false))

    if(this.state.editFlag){


        apiService.editKitchen(apiPayloadData,this.state.kitchenData.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditKitchenReady(true))
                        this.props.history.push("/dashboard/kitchens/list")
                    } else {

                        this.props.dispatch(addEditKitchenReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditKitchenReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


        }else{

        apiService.addKitchen(apiPayloadData)
                .then(responseData => {
                     
                        if (responseData.status === "SUCCESS") {
                            this.props.dispatch(addEditKitchenReady(true))
                            this.props.history.push("/dashboard/kitchens/list")
                        } else {

                            this.props.dispatch(addEditKitchenReady(true))
                            this.dialog.show({
                                title: "Alert",
                                body: responseData.reason ? responseData.reason : "",
                                actions: [
                                    Dialog.OKAction(() => {
                                    })
                                ],
                            })
                        }
                    
                })
                .catch(err => {
                    this.props.dispatch(addEditKitchenReady(true))
                    console.error("Error data: ", err)
                   alert("exception"+ err);
                })


        }

        
    }


    

    countInPutChange = (row,e) => {

    let budgetedKitchenStaffData = this.state.budgetedKitchenStaffData;

    let total=0;

    budgetedKitchenStaffData.map(function(item, index) {
        if (item['brand_group_id'] === row.brand_group_id) {
            item.count = e.target.value
        }
        total+=item['count']!=="" ? parseInt(item['count'],10) : 0
        return true
    })

     this.setState({
        budgetedKitchenStaffData: budgetedKitchenStaffData,
        totalBudegetedCounts : total
    });

}



    integerValidation = (value) => {
        if (/\D/.test(value)) {
            return true
        } else {
            return false
        }
    }

    onCancelClick = () => {
        this.props.history.goBack()
    }
    
    render() {
        return (
            <div className="line-item-edit">
            <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>
                <Dialog ref={el => this.dialog = el} />
                <section className="content">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
                            <div className="box box-info" style={{ borderTop: "0px" }}>
                                <div className="box-header with-border">
                                    <h3 className="box-title" style={{ fontWeight: 600 }}>{this.state.subTitle}</h3>
                                </div>
                                <div className="form-horizontal">
                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.kitchenNameSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}> Name *</label>
                                                    <div className="col-sm-9">
                                                        <input className="form-control" placeholder="Enter Kitchen Name" type="text" ref={el => this.kitchenNameComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("kitchenName")}} />
                                                        <span className="help-block"style={{display: this.state.kitchenNameErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.kitchenNameErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>


                                             <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el =>
                                                   this.kitchenCodeSection = el}>
                                                   <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Code *</label>
                                                   <div className="col-sm-9">
                                                      <input className="form-control" placeholder="Enter Kitchen Code" type="text" ref={el => this.kitchenCodeComponent = el}
                                                      onChange={(e) => {e.preventDefault() 
                                                      this.keyedInputChange("kitchenCode")}} />
                                                      <span className="help-block" style={{ display: this.state.kitchenCodeErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                      {this.state.kitchenCodeErrorData}
                                                      </span>
                                                   </div>
                                                </div>
                                             </div>

                                           
                                        </div>



                                        <div className="col-md-12 col-sm-12 col-xs-12">

                                                    <div className="col-md-6 col-sm-12 col-xs-12">
                                                        <div className="form-group" ref={el => this.cityIdSection = el}>
                                                            <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>City *</label>
                                                            <div className="col-sm-9" ref={el => this.cityIdComponent = el}>
                                                                
                                                                 <Cities cityChange={this.cityChange} selectedValue={this.state.cityId} />

                                                                <span className="help-block"style={{display: this.state.cityIdErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                                    {this.state.cityIdErrorData}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                     <div className="col-md-6 col-sm-12 col-xs-12">
                                                        <div className="form-group" ref={el =>
                                                           this.contactNoSection = el}>
                                                           <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Contact No *</label>
                                                           <div className="col-sm-9">
                                                              <input className="form-control" placeholder="Enter Contact No" type="number" ref={el => this.contactNoComponent = el}
                                                              onChange={(e) => {e.preventDefault() 
                                                              this.keyedInputChange("contactNo")}} />
                                                              <span className="help-block" style={{ display: this.state.contactNoErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                              {this.state.contactNoErrorData}
                                                              </span>
                                                           </div>
                                                        </div>
                                                     </div>


                                            </div>

                                            <div className="col-md-12 col-sm-12 col-xs-12">


                                               <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.clusterIdSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Cluster *</label>
                                                    <div className="col-sm-9" ref={el => this.clusterIdComponent = el}>
                                                        
                                                         <ClusterCombo clusterChange={this.clusterIdChange} selectedValue={this.state.clusterId} />

                                                        <span className="help-block"style={{display: this.state.clusterIdErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.clusterIdErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                                </div>
                                                 <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.managerIdSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Kitchen Manager</label>
                                                    <div className="col-sm-9" ref={el => this.managerIdComponent = el}>
                                                        
                                                         <Employees type="km_list" employeeChange={this.managerIdChange} selectedValue={this.state.managerId} />

                                                        <span className="help-block"style={{display: this.state.managerIdErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.managerIdErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>


                                            </div>



                                            <div className="col-md-12 col-sm-12 col-xs-12">


                                                     <div className="col-md-6 col-sm-12 col-xs-12">
                                                        <div className="form-group" ref={el =>
                                                           this.latSection = el}>
                                                           <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Latitude </label>
                                                           <div className="col-sm-9">
                                                              <input className="form-control" placeholder="Enter Latitude" type="number" ref={el => this.latComponent = el}
                                                              onChange={(e) => {e.preventDefault() 
                                                              this.keyedInputChange("lat")}} />
                                                              <span className="help-block" style={{ display: this.state.latErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                              {this.state.latErrorData}
                                                              </span>
                                                           </div>
                                                        </div>
                                                     </div>

                                                         <div className="col-md-6 col-sm-12 col-xs-12">
                                                            <div className="form-group" ref={el =>
                                                               this.lngSection = el}>
                                                               <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Longitude </label>
                                                               <div className="col-sm-9">
                                                                  <input className="form-control" placeholder="Enter lngitude" type="number" ref={el => this.lngComponent = el}
                                                                  onChange={(e) => {e.preventDefault() 
                                                                  this.keyedInputChange("lng")}} />
                                                                  <span className="help-block" style={{ display: this.state.lngErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                                  {this.state.lngErrorData}
                                                                  </span>
                                                               </div>
                                                            </div>
                                                         </div>



                                            </div>



                                            <div className="col-md-12 col-sm-12 col-xs-12">

                                             <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el =>
                                                   this.BudgetedKmSection = el}>
                                                   <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Budgeted KMs </label>
                                                   <div className="col-sm-9">
                                                      <input className="form-control" placeholder="Enter Budgeted KMs" type="number" ref={el => this.BudgetedKmComponent = el}
                                                      onChange={(e) => {e.preventDefault() 
                                                      this.keyedInputChange("BudgetedKm")}} />
                                                      <span className="help-block" style={{ display: this.state.BudgetedKmErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                      {this.state.BudgetedKmErrorData}
                                                      </span>
                                                   </div>
                                                </div>
                                             </div>


                                             <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el =>
                                                   this.BudgetedSmSection = el}>
                                                   <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Budgeted SMs </label>
                                                   <div className="col-sm-9">
                                                      <input className="form-control" placeholder="Enter Budgeted SMs" type="number" ref={el => this.BudgetedSmComponent = el}
                                                      onChange={(e) => {e.preventDefault() 
                                                      this.keyedInputChange("BudgetedSm")}} />
                                                      <span className="help-block" style={{ display: this.state.BudgetedSmErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                      {this.state.BudgetedSmErrorData}
                                                      </span>
                                                   </div>
                                                </div>
                                             </div>



                                            </div>



                                            <div className="col-md-12 col-sm-12 col-xs-12">

                                             <div className="col-md-6 col-sm-12 col-xs-12">
                                                    <div className="form-group" ref={el =>
                                                       this.BudgetedAkmSection = el}>
                                                       <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Budgeted AKMs </label>
                                                       <div className="col-sm-9">
                                                          <input className="form-control" placeholder="Enter Budgeted AKMs" type="number" ref={el => this.BudgetedAkmComponent = el}
                                                          onChange={(e) => {e.preventDefault() 
                                                          this.keyedInputChange("BudgetedAkm")}} />
                                                          <span className="help-block" style={{ display: this.state.BudgetedAkmErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                          {this.state.BudgetedAkmErrorData}
                                                          </span>
                                                       </div>
                                                    </div>
                                                 </div>

                                             <div className="col-md-6 col-sm-12 col-xs-12">
                                                    <div className="form-group" ref={el =>
                                                       this.BudgetedHkSection = el}>
                                                       <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Budgeted HKs </label>
                                                       <div className="col-sm-9">
                                                          <input className="form-control" placeholder="Enter Budgeted HKs" type="number" ref={el => this.BudgetedHkComponent = el}
                                                          onChange={(e) => {e.preventDefault() 
                                                          this.keyedInputChange("BudgetedHk")}} />
                                                          <span className="help-block" style={{ display: this.state.BudgetedHkErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                          {this.state.BudgetedHkErrorData}
                                                          </span>
                                                       </div>
                                                    </div>
                                                 </div>

                                                  

                                                




                                            </div>


                                            <div className="col-md-12 col-sm-12 col-xs-12">

                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.statusSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Status *</label>
                                                    <div className="col-sm-9" ref={el => this.statusComponent = el}>
                                                        
                                                         <EntityStatus type="KITCHENS" entityStatusChange={this.statusChange} selectedValue={this.state.status} />

                                                        <span className="help-block"style={{display: this.state.statusErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.statusErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>


                                        
                                        </div>


                                <div className="box box-info" style={{ borderTop: "0px" }}>
                                    <div className="box-header with-border">
                                        <h3 className="box-title" style={{ fontWeight: 600 }}>Budgeted Kitchen Staffs [ Total : {this.state.totalBudegetedCounts} ]</h3>
                                    </div>
                                    <div className="row" style={{marginTop:"2%"}}>

                                    <div className="col-md-12">
                                    <div className="col-md-3 col-md-offset-1">

                                                <table className="table table-bordered" style={{textAlign:"left"}}>
                                    
                                                        <thead>
                                                            <tr><th>Workstation</th><th style={{width: "40%"}}>Counts</th></tr>
                                                        </thead>
                                                        <tbody>
                                                         {this.state.budgetedKitchenStaffData.map((item, index) => (

                                                            <tr>
                                                            <td>{this.state.budgetedKitchenStaffData[index].name}</td>
                                                            <td><input className="form-control" type="number" value={this.state.budgetedKitchenStaffData[index].count} onChange={(e) => {
                                                            this.countInPutChange(this.state.budgetedKitchenStaffData[index],e)
                                                        }}/></td>
                                                            </tr>
                                                            ))}
                                                        </tbody>
                                                        </table>

                                        

                                    </div>
                                    </div>
                                    </div>

                                </div>

                                    <div className="box-footer">
                                        <button
                                            className="btn btn-default"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onCancelClick()
                                            }}>
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-info pull-right"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onSaveClick()
                                            }}>
                                            Save Changes
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }

    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }

}
function mapStateToProps(state) {
    return {
        kitchens: state.kitchens,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(AddEditKitchen))


// WEBPACK FOOTER //
// ./src/modules/Kitchens/Components/AddEditKitchen.js